import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className", "children", "requiredIndicator", "optionalIndicator"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useFormControlContext, useFormControlStyles } from "./chunk-6ZNYZUDD.mjs";

// src/form-label.tsx
import { chakra, forwardRef, omitThemingProps, useStyleConfig } from "@chakra-ui/system";
import { cx } from "@chakra-ui/shared-utils";
import { jsx, jsxs } from "react/jsx-runtime";
var FormLabel = forwardRef(function FormLabel2(passedProps, ref) {
  var _a;
  var styles = useStyleConfig("FormLabel", passedProps);
  var props = omitThemingProps(passedProps);
  var className = props.className,
    children = props.children,
    _props$requiredIndica = props.requiredIndicator,
    requiredIndicator = _props$requiredIndica === void 0 ? /* @__PURE__ */jsx(RequiredIndicator, {}) : _props$requiredIndica,
    _props$optionalIndica = props.optionalIndicator,
    optionalIndicator = _props$optionalIndica === void 0 ? null : _props$optionalIndica,
    rest = _objectWithoutProperties(props, _excluded);
  var field = useFormControlContext();
  var ownProps = (_a = field == null ? void 0 : field.getLabelProps(rest, ref)) != null ? _a : _objectSpread({
    ref: ref
  }, rest);
  return /* @__PURE__ */jsxs(chakra.label, _objectSpread(_objectSpread({}, ownProps), {}, {
    className: cx("chakra-form__label", props.className),
    __css: _objectSpread({
      display: "block",
      textAlign: "start"
    }, styles),
    children: [children, (field == null ? void 0 : field.isRequired) ? requiredIndicator : optionalIndicator]
  }));
});
FormLabel.displayName = "FormLabel";
var RequiredIndicator = forwardRef(function RequiredIndicator2(props, ref) {
  var field = useFormControlContext();
  var styles = useFormControlStyles();
  if (!(field == null ? void 0 : field.isRequired)) return null;
  var className = cx("chakra-form__required-indicator", props.className);
  return /* @__PURE__ */jsx(chakra.span, _objectSpread(_objectSpread({}, field == null ? void 0 : field.getRequiredIndicatorProps(props, ref)), {}, {
    __css: styles.requiredIndicator,
    className: className
  }));
});
RequiredIndicator.displayName = "RequiredIndicator";
export { FormLabel, RequiredIndicator };